import { OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import type { CloneRecordButtonFieldProps } from './clone-record-button-field.component';
import CloneRecordButtonField from './clone-record-button-field.component';

interface HfCloneRecordButtonFieldProps extends CloneRecordButtonFieldProps {
  control?: Control;
  name?: string;
}

function HfCloneRecordButtonField({
  id,
  name = 'clone_record_button',
  control,
  buttonCaption,
  recordId,
  cloneRecordBackgroundJobItemText,
  readOnly,
  saveRecord,
  recordSaveState,
  formId,
  shouldUseCloneWizzard,
  cloneWizardTargetPersonField,
  cloneWizardTargetWorkflowStep,
  allowUserAttachmentCloning,
  moduleFormCloneTargetId,
}: HfCloneRecordButtonFieldProps) {
  return (
    <OdinController
      name={name}
      control={control}
      render={() => (
        <CloneRecordButtonField
          id={id}
          buttonCaption={buttonCaption}
          recordId={recordId}
          cloneRecordBackgroundJobItemText={cloneRecordBackgroundJobItemText}
          readOnly={readOnly}
          saveRecord={saveRecord}
          recordSaveState={recordSaveState}
          formId={formId}
          shouldUseCloneWizzard={shouldUseCloneWizzard}
          cloneWizardTargetPersonField={cloneWizardTargetPersonField}
          cloneWizardTargetWorkflowStep={cloneWizardTargetWorkflowStep}
          allowUserAttachmentCloning={allowUserAttachmentCloning}
          moduleFormCloneTargetId={moduleFormCloneTargetId}
        />
      )}
    />
  );
}

export default HfCloneRecordButtonField;
